export default {
    install(app, options) {
        app.config.globalProperties.$_ = {
            eachSlice:  (array, num) => Array.from(
                { length: Math.ceil(array.length / num) },
                (_, i) => array.slice(i * num, i * num + num)
            )
        };
    }
}
